import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import StaffAllocationForm from './StaffAllocationForm';
import { DATE_FORMAT_NO_YEAR } from '../../../helpers/dates';
import moment from 'moment';

const useStyles = makeStyles(theme => ({
  staffAllocationDialog: {
    backgroundColor: theme.palette.background.default,
  },
}));

const StaffAllocationDialog = ({ users, event, onSubmit, onClose, isOpen }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const classes = useStyles();

  return (
    <Dialog
      classes={{
        paper: classes.staffAllocationDialog,
      }}
      fullScreen={fullScreen}
      open={isOpen}
      onClose={onClose}
    >
      <DialogTitle>{`${moment(event.start).format(
        DATE_FORMAT_NO_YEAR
      )}\u00A0\u00A0${event.flightNumber}\u00A0\u00A0${event.inboundAirport}-${
        event.airport
      }-${event.outboundAirport}`}</DialogTitle>
      <DialogContent>
        <StaffAllocationForm
          event={event}
          users={users}
          onClose={onClose}
          onSubmit={onSubmit}
        />
      </DialogContent>
    </Dialog>
  );
};

export default StaffAllocationDialog;
